import React from 'react'
import Menu from '../component/Menu';
// import Buspotential from '../component/Buspotential'
import Getintouch2 from '../component/Getintouch2'
import FooterNew from '../component/FooterNew';
import Whoweserve from '../component/Whoweserve'
//import Wehelp from '../component/Wehelp'
import Financialadheader from '../component/Financialadheader'
import Whatwedo1 from '../component/Whatwedo1'
import { Helmet } from 'react-helmet';

const Financialadvisory = ({setBlank}) => {
    // const paragraph = "Arranging and allocating financial resources to maximize profitability and drive sustainable growth is complex and challenging. Our team of seasoned financial consultants combine years of industry expertize with analytical rigour to create custom solutions that will help you navigate complex financial challenges, seize opportunities and make informed decisions."
    return (
        <>
            <Helmet>
                <title>Investment Advisory</title>
                <meta property="og:title" content="Investment Advisory" />
                <meta name='og:description' content='Investment Advisory' />
                <meta name='keywords' content='' />
            </Helmet>
            <Menu setBlank={setBlank} />
            <Financialadheader />
            {/* <Buspotential paragraph={paragraph} /> */}
            <Whatwedo1 />
            <Whoweserve />
            <Getintouch2 setBlank={setBlank} />
            <FooterNew setBlank={setBlank} />
        </>
    )
}

export default Financialadvisory